import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import Desmos from 'desmos';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssignmentQuestionService } from '../../services/assignment-question.service';

@Component({
  selector: 'ngx-desmos-graph',
  templateUrl: './desmos-graph.component.html',
  styleUrls: ['./desmos-graph.component.scss'],
  providers: [NgxSpinnerService],
})
export class DesmosGraphComponent implements OnInit {
  @ViewChild('test', { static: true }) public test: ElementRef;
  private calculator: Desmos.GraphingCalculator;
  updateAssignmentMedia;
  @Input() isAssessments;
  @Output() generatedImage = new EventEmitter<any>();
  public loading = false;
  constructor(
    private questionService: AssignmentQuestionService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    const elt = this.test.nativeElement;
    elt.innerHTML = '';
    this.calculator = Desmos.GraphingCalculator(elt);
  }

  async saveGraphImageForOption() {
    try {
      this.loading = true;
      const imageDataUrl = this.calculator.screenshot({
        width: 400,
        height: 400,
        targetPixelRatio: 2,
      });
      const data = {
        type: 'image',
        media: imageDataUrl,
      };
      const response: any = await this.questionService.uploadMedia(data, this.isAssessments ? true : false);
      if (response && response.id) {
        this.generatedImage.emit(response);
      }

      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
}
